import { render, staticRenderFns } from "./Bats.vue?vue&type=template&id=713c8158"
import script from "./Bats.vue?vue&type=script&lang=js"
export * from "./Bats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports